"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllHashers = void 0;
/* eslint-disable sort-keys */
exports.AllHashers = {
    Blake2_128: null,
    Blake2_256: null,
    Blake2_128Concat: null,
    Twox128: null,
    Twox256: null,
    Twox64Concat: null,
    // new in v11
    Identity: null
};
